<template lang="pug">
  Modal(v-if="uploader")
    Gallery(:uploader="uploader")
</template>
<script>
import Modal from '../general/Modal';
import Spinner from '../general/Spinner';
import moment from 'moment';
import Gallery from 'vue-fineuploader/gallery';
import FineUploaderS3 from 'fine-uploader-wrappers/s3';
import { postResource } from '../../services/Utils.js';
import Services from '../../services/Services.js';
import store from '../../store';
export default {
  name: 'UpdateThumbModal',
  components: {
    Gallery,
    Modal,
    Spinner
  },
  data() {
    return {
      loadedUploader: false,
      uploader: null
    };
  },
  methods: {
    setupUploader: () =>
      new Promise(async (resolve, reject) => {
        try {
          const res = await postResource('/v1/media/sign');
          const fineUploader = new FineUploaderS3({
            options: {
              request: {
                endpoint: 'https://uploads-mediamobz-com.s3.amazonaws.com',
                accessKey: 'AKIAICDZPSI6TDKJZCWA',
                version: 4
              },
              signature: {
                endpoint: `https://glxstudio.com/api/pub/upload?expire=${
                  res.stamp
                }&sig=${encodeURIComponent(res.sig)}&id=${encodeURIComponent(
                  res.id
                )}`
              },
              callbacks: {
                onComplete: (id, name, response, xhr) => {
                  console.log(id);
                  postResource(
                    `/v1/media/update?mediaId=${
                      store.getters.getActiveMedia._id
                    }`,
                    false,
                    {
                      'thumb-key': fineUploader.methods.getKey(id)
                    }
                  )
                    .then(res2 => {
                      if (res2.status === 'success') {
                        store.commit('setMediaLoadedStatus', false);
                        Services.getMediaByMarket(
                          store.getters.getActiveMarket._id
                        );
                        store.commit('showUpdateThumbModal', false);
                        return store.commit('setActiveMedia', res2.media);
                      } else {
                        console.log(res2);
                        return store.commit('showUpdateThumbModal', false);
                      }
                    })
                    .catch(err => {
                      console.log(err);
                      // this.showErrorMsg({
                      //   message: 'An error occurred. Please try again.'
                      // });
                    });
                }
              }
            }
          });
          return resolve(fineUploader);
        } catch (error) {
          return reject(error);
        }
      })
  },
  mounted() {
    this.setupUploader()
      .then(uploader => {
        this.uploader = uploader;
      })
      .catch(error => console.log(error));
  }
};
</script>



// WEBPACK FOOTER //
// src/components/modals/UpdateThumb.vue